
window.addEventListener("load", function () {
  document.body.classList.add("page-loaded");
});


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("#header-component");
  if (!header) return;

  function updateMenuStyle() {
    const desired = window.innerWidth < 750 ? "drawer" : "menu";

    if (header.getAttribute("data-menu-style") !== desired) {
      header.setAttribute("data-menu-style", desired);
    }
  }

  // Run once
  updateMenuStyle();

  // Resize (debounced)
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateMenuStyle, 100);
  });

  // 🔥 IMPORTANT: watch Shopify changes and override instantly
  const observer = new MutationObserver(() => {
    updateMenuStyle();
  });

  observer.observe(header, {
    attributes: true,
    attributeFilter: ["data-menu-style"],
  });
});

document.getElementById("loadMore")?.addEventListener("click", function() {
  const hiddenPosts = document.querySelectorAll(".hidden-post");

  hiddenPosts.forEach((el, index) => {
    if (index < 7) {
      el.style.display = "block";
      el.classList.remove("hidden-post");
    }
  });

  if (document.querySelectorAll(".hidden-post").length === 0) {
    this.style.display = "none";
  }
});


/* Quote My Dream Ring — thank-you message after the quote form (Globo / Powerful Form Builder, form 144066) is submitted.
   The app shows its own `.message.success` box (title + text come from the app's "After submit" settings, currently the
   generic "Thanks for getting in touch!" template). This swaps in our copy at load and again on the app's submitted event,
   so the box reads correctly even if the app re-renders. Styling is in custom.css (".message.success"). */
(function () {
  var FORM_ID = "144066";
  var TITLE = "Thank you — your quote request is on its way!";
  var BODY =
    "<p>We’ve received your ring details and one of our jewelers will personally review them. " +
    "Expect to hear from us within some business day (usually much sooner) with diamond options, setting ideas and pricing.</p>" ;

  function applyCopy() {
    var root = document.getElementById("globo-formbuilder-" + FORM_ID);
    if (!root) return;
    root.querySelectorAll(".message.success").forEach(function (box) {
      if (box.getAttribute("data-ge-thankyou") === "1") return;
      var title = box.querySelector(".gfb__content-title");
      var content = box.querySelector(".content");
      if (title) title.textContent = TITLE;
      if (content) content.innerHTML = BODY;
      box.setAttribute("data-ge-thankyou", "1");
    });
  }

  document.addEventListener("DOMContentLoaded", applyCopy);
  document.addEventListener("globo.formbuilder.form.submitted", function (e) {
    if (e.detail && String(e.detail.formId) === FORM_ID) applyCopy();
  });
  // the app can re-render the form after load (drafts, conditional logic) — re-apply when the box is recreated
  var mo = new MutationObserver(function () { applyCopy(); });
  document.addEventListener("DOMContentLoaded", function () {
    var root = document.getElementById("globo-formbuilder-" + FORM_ID);
    if (root) mo.observe(root, { childList: true, subtree: true });
  });
})();
